const applyInvoice = {
  path: 'applyInvoice',
  component: resolve => require(['../../../../components/pages/signUp/applyInvoice'], resolve)
}
export default applyInvoice



// WEBPACK FOOTER //
// ./src/router/pages/signUp/applyInvoice/index.js